module.exports = __webpack_public_path__ + "img/realized-private.50f2e82a.png";